import { collector } from "../collector";
import { transport } from "../transport";
import { sanitizeUrl } from "../redact";

// Session lifecycle + page visibility. The modern, reliable "session may be
// ending" signal is visibilitychange->hidden (+ pagehide fallback). We never use
// unload/beforeunload (bfcache-hostile, unreliable on mobile, being deprecated).
export function startLifecycle() {
  collector.track("session_start", {
    entryUrl: sanitizeUrl(window.location.href),
    referrer: sanitizeUrl(document.referrer),
    ua: navigator.userAgent,
    lang: navigator.language,
    tz: (Intl.DateTimeFormat().resolvedOptions() || {}).timeZone || null,
    screen: { w: window.screen && window.screen.width, h: window.screen && window.screen.height },
    viewport: { w: window.innerWidth, h: window.innerHeight },
    dpr: window.devicePixelRatio || 1,
  });

  const onVisibility = () => {
    collector.track("visibility_change", { state: document.visibilityState });
    if (document.visibilityState === "hidden") transport.flushOnHidden();
  };
  const onPageHide = () => {
    collector.track("session_end", { reason: "pagehide" });
    transport.flushOnHidden();
  };

  document.addEventListener("visibilitychange", onVisibility);
  window.addEventListener("pagehide", onPageHide);

  return () => {
    document.removeEventListener("visibilitychange", onVisibility);
    window.removeEventListener("pagehide", onPageHide);
  };
}
